var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tick_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tick_svg__b)",
    d: "m44.118 12.386-5.883-2.617-2.62-5.886-6.403.668-5.21-3.778-5.212 3.778-6.4-.668-2.618 5.883-5.886 2.62.67 6.403L.776 24l3.778 5.212-.669 6.4 5.884 2.617 2.62 5.886 6.403-.668 5.21 3.778 5.212-3.778 6.4.669 2.617-5.884 5.886-2.62-.669-6.403 3.779-5.21-3.779-5.212zm-24.76 20.903-6.573-6.573 2.19-2.183 4.382 4.374 13.138-13.138 2.19 2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tick_svg__c)",
    d: "m47.852 23.545-3.605-4.972.639-6.108a.775.775 0 0 0-.456-.788L38.82 9.18l-2.497-5.61a.78.78 0 0 0-.788-.457l-6.109.639L24.454.147a.77.77 0 0 0-.909 0l-4.972 3.605-6.108-.639a.785.785 0 0 0-.789.455L9.18 9.18l-5.612 2.497a.77.77 0 0 0-.455.788l.639 6.108-3.605 4.972a.77.77 0 0 0 0 .909l3.605 4.972-.639 6.109a.77.77 0 0 0 .455.788L9.18 38.82l2.496 5.61a.78.78 0 0 0 .789.457l6.108-.64 4.972 3.606a.77.77 0 0 0 .909 0l4.972-3.605 6.109.639c.333.033.65-.15.788-.455l2.497-5.612 5.61-2.497a.775.775 0 0 0 .456-.788l-.639-6.108 3.605-4.972a.77.77 0 0 0 0-.91m-5.032 5.213a.77.77 0 0 0-.144.535l.61 5.843-5.368 2.39a.77.77 0 0 0-.394.392l-2.388 5.37-5.845-.611a.77.77 0 0 0-.534.144L24 46.269l-4.758-3.448a.77.77 0 0 0-.454-.148q-.041 0-.078.003l-5.845.611-2.388-5.368a.77.77 0 0 0-.393-.394l-5.372-2.39.61-5.842a.78.78 0 0 0-.143-.535L1.73 24l3.448-4.758a.78.78 0 0 0 .143-.535l-.61-5.844 5.369-2.39a.77.77 0 0 0 .393-.392l2.388-5.37 5.845.612c.19.019.38-.033.535-.144L24 1.73l4.758 3.448a.78.78 0 0 0 .534.144l5.845-.611 2.388 5.369a.77.77 0 0 0 .394.393l5.368 2.389-.61 5.844c-.02.19.031.38.144.535L46.268 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tick_svg__d)",
    d: "m19.354 32.199-5.477-5.478 1.094-1.092 3.836 3.828a.774.774 0 0 0 1.094 0l12.59-12.588 1.097 1.096z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tick_svg__e)",
    d: "M33.043 15.219a.774.774 0 0 0-1.095 0l-12.59 12.59-3.835-3.827a.774.774 0 0 0-1.093 0l-2.195 2.181a.774.774 0 0 0 0 1.096l6.573 6.573a.775.775 0 0 0 1.095 0l15.328-15.328a.775.775 0 0 0 0-1.095zM19.358 32.191l-5.478-5.477 1.095-1.092 3.836 3.828a.774.774 0 0 0 1.094 0l12.59-12.59 1.097 1.097z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick_svg__b",
    x1: 40.199,
    x2: 9.599,
    y1: -2.4,
    y2: 46.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F4D638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B77C23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick_svg__c",
    x1: 52.79,
    x2: -25.581,
    y1: -21.135,
    y2: 42.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick_svg__d",
    x1: 37.794,
    x2: 5.995,
    y1: 6.605,
    y2: 38.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick_svg__e",
    x1: 37.798,
    x2: 5.998,
    y1: 6.597,
    y2: 38.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6D7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tick_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgTick;